import { isAxiosError } from 'axios';
import { log } from '@/logger/logger.ts';
import { getAxiosInstance } from '@/services/axiosConfig';

const logger = log.getLogger('api.utils');
const axiosInstance = getAxiosInstance();

export const httpReq = async <T, V>(
  url: string,
  body?: T,
  method: 'get' | 'post' | 'put' | 'patch' | 'delete' = 'post',
): Promise<V> => {
  try {
    const res =
      method === 'get' || method === 'delete'
        ? await axiosInstance[method]<V>(url)
        : await axiosInstance[method]<V>(url, body);
    return res.data;
  } catch (e) {
    logger.error(`Error in ${method} request:`, e);
    throw e;
  }
};

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    return (error.response?.data as { message?: string })?.message || fallback;
  }
  return fallback;
}
